module.exports = __webpack_public_path__ + "static/media/phone7.23d88354.png";